import useScrollLock from '../../utils/useScrollLock';

/*
  Generic modal shell for forms (add/edit product, etc.).
*/
export default function FormModal({ open, title, onClose, children, wide }) {
  useScrollLock(open);

  if (!open) return null;

  return (
    <div className="admin-modal-overlay" onClick={onClose}>
      <div
        className={`admin-modal ${wide ? 'admin-modal-wide' : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="admin-modal-header">
          <h3>{title}</h3>
          <button className="modal-x" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <div className="admin-modal-body">{children}</div>
      </div>
    </div>
  );
}
